import React, { useMemo } from 'react';
import { useLoggedInUser, useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { useUserLoggedInConfigs, useFeatureFlagsConfigs } from '../../utils/sharedData';
import { Operation } from '../../hooks/useOperations/types';
import { useImpersonatedOperation } from '../../hooks/useImpersonatedOperation';

interface IProps {
  operations: Operation[];
  operationsSelected: string[];
}

const S3Plugin = React.lazy(() => importFromS3('script-creator-plugin'));
const MFPlugin = React.lazy(() => import('tccScriptCreatorPlugin/TccScriptCreatorPlugin'));

export const ScriptCreatorPluginContainer: React.FC<IProps> = ({ operations, operationsSelected }: IProps) => {
  const { isLoading, operation: impersonatedOperation } = useImpersonatedOperation();
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs(user));
  const useModuleFederation = featureFlags?.['web.scriptCreator.module-federation'];

  const ScriptCreatorPlugin = useModuleFederation ? MFPlugin : S3Plugin;

  const selectedOperations = useMemo(() => impersonatedOperation
    ? [impersonatedOperation.operationId]
    : operationsSelected,
  [impersonatedOperation, operationsSelected]);

  if (isLoading || !selectedOperations.length) return null;
  return (
    <ScriptCreatorPlugin
      operations={operations}
      operationsSelected={selectedOperations}
    />
  );
};
